import { Box } from '@mantine/core'
import { useRef } from 'react'
import type { BoggleStore } from '~/boggle/ui/state/Store'
import { useBogglePixiRuntime } from './pixi/usePixiRuntime'

export function Canvas({ store }: { store: BoggleStore }) {
  const hostRef = useRef<HTMLDivElement | null>(null)
  useBogglePixiRuntime({ hostRef, store })

  return <Box h="100%" ref={hostRef} w="100%" />
}
